export const BRANDS_DATA = [  
  {
    name: "Rideon",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/1zlm0fr7_colour%20png.png",
    description: "Move Forward — OEM quality automotive parts and accessories brand.",
    category: "Auto Parts & Accessories",
    website: null,
  },
  {
    name: "Bosch",
    logo_url: "https://www.boschautoparts.com/o/bosch-autoparts-theme/images/bosch-logo.svg",
    description: "World-leading automotive parts manufacturer – filters, spark plugs, and electrical components.",
    category: "Spark Plugs",
    website: "https://www.boschautoparts.com",
  },
  {
    name: "Delux Bearings",
    logo_url: "https://deluxbearings.com/wp-content/uploads/2024/07/LOGO-DELUX.png",
    description: "India's trusted manufacturer of high-quality bearings for automotive applications.",
    category: "Bearings",
    website: "https://deluxbearings.com",
  },
  {
    name: "Lumax",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/gbp97ot3_LUMAXIND.NS_BIG-80633668.png",
    description: "Leading manufacturer of automotive lighting and signalling equipment.",
    category: "Lighting & Electricals",
    website: "https://lumaxworld.com",
  },
  {
    name: "Lucas TVS",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/nkqq0a55_Lucas%20TVS.png",
    description: "Premium automotive electrical components and systems manufacturer.",
    category: "Electric Parts",
    website: "https://lucas-tvs.com",
  },
  {
    name: "Gabriel",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/2gextc1r_Gabriel%20logo.png",
    description: "India's leading ride control products manufacturer — shock absorbers and struts.",
    category: "Suspension & Ride Control",
    website: "https://gabrielindia.com",
  },
  {
    name: "Power",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/g33y9qjj_Powe%20logo.png",
    description: "Reliable brand for automotive Ignition coils and Elctric parts.",
    category: "Electric parts",
    website: null,
  },
  {
    name: "ASK",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/8wfnss8z_ASK.jpg",
    description: "OEM Manufacturer of Brake shoe and Brake Pads.",
    category: "Brake shoes",
    website: null,
  },
  {
    name: "MK Lide",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/p0hgqner_MK%20Lide.jpg",
    description: "Quality manufacturer of clutch plates and friction materials for automotive applications.",
    category: "Clutch & Friction",
    website: null,
  },
  {
    name: "India Nippon Electricals",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/tpfoh3vr_india-nippon1.png",
    description: "Leading manufacturer of ignition systems and electronic components for two-wheelers and automotive applications.",
    category: "Electric Parts",
    website: null,
  },
  {
    name: "Waxpol",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/zo46zhij_Waxpol%20Logo.jpg",
    description: "Leading Vehicle care and maintenance polish and lube products brand in India.",
    category: "Car Care Products",
    website: "https://waxpol.com",
  },
  {
    name: "Napino Continental",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/pzazz9y7_ncve.jpg",
    description: "Joint venture specialising in high-quality auto electricals and electronic components.",
    category: "Electric Parts",
    website: null,
  },
  {
    name: "Ucal",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/lfbyfjkg_Ucal-.png",
    description: "Specialist in fuel system components, carburettors and fuel injection systems for automotive.",
    category: "Fuel Systems",
    website: null,
  },
  {
    name: "AE",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/tgt3ocsi_AE%20logo.png",
    description: "TVS Oem CDI/TCI ",
    category: "Electric Parts",
    website: null,
  },
  {
    name: "Bagla",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/17gtpz9d_bagla.jpg",
    description: "OEM Starter Relays",
    category: "Electric Parts",
    website: null,
  },
  {
    name: "Advik",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/vmq7qesx_Advik.png",
    description: "Passionately innovative manufacturer of Hi-Tech automotive components.",
    category: "Auto Components",
    website: null,
  },
  {
    name: "GAE",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/lsa91k4o_gulati_auto_electricals_cover.jfif",
    description: "Manufacturer of precision-engineered automotive electrical parts.",
    category: "Petrol Tank Locks",
    website: null,
  },
  {
    name: "AR Petrol Tap",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/3zr37ws2_AR%20P.tee.jpg",
    description: "Specialist manufacturer of fuel system components and petrol taps.",
    category: "Fuel System Components",
    website: null,
  },
  {
    name: "MK Auto",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/vgq6tw2m_MK%20Auto.png",
    description: "Quality automotive spare parts and accessories for the Indian aftermarket.",
    category: "Brake Shoes and CLutch Plates",
    website: null,
  },
  {
    name: "Remsons",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/7nqi08au_Remsons.png",
    description: "Trusted brand for automotive control cables and allied products.",
    category: "Cables & Controls",
    website: "https://remsons.com",
  },
  {
    name: "Gates",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/4vo06ngi_GatesCorporation_Logo.png",
    description: "Global leader in power transmission belts and fluid power products for automotive applications.",
    category: "Belts & Hoses",
    website: "https://www.gates.com",
  },
  {
    name: "Larex",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/ozydsfic_Larex%20logo.png",
    description: "Trusted manufacturer of control cables and speedo cables for automobiles.",
    category: "Cables & Controls",
    website: null,
  },
  {
    name: "Pricol",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/owxzul10_Pricol%20Logo.png",
    description: "Leading manufacturer of automotive instruments, fuel level sensors and driver information systems.",
    category: "Instruments & Sensors",
    website: "https://www.pricol.com",
  },
  {
    name: "Spaco",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/gm513bd0_spaco.png",
    description: "Trusted manufacturer of diesel fuel injection components and spare parts.",
    category: "Fuel Injection",
    website: null,
  },
  {
    name: "Sandhar",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/0dzqvi8z_SANDHAR.png",
    description: "Major automotive components manufacturer — locks, mirrors, handles and sheet metal parts.",
    category: "Locks & Body Parts",
    website: "https://www.sandhargroup.com",
  },
  {
    name: "Ars-HTA",
    logo_url: "https://customer-assets.emergentagent.com/job_rk-automotive-hub/artifacts/bbgi8k8n_ars-hta.png",
    description: "Manufacturer of high-quality automotive Rubber Parts and Seals.",
    category: "Seals",
    website: null,
  },
];
